import { useTileFilters } from '@/catalog-apps/hooks/useTileFilters'
import { TileFilter } from '../shared/TileFilter'
import { useGetDataTableV2 } from '../DataTableV2/useGetDataTableV2'
import { DataTableV2Content } from '../DataTableV2/DataTableV2Content'

export function SheetDataTableV2Component({ contentId }: { contentId: string }) {
  const { tileFilterSelections } = useTileFilters()
  const { data, refetch, isRefetching } = useGetDataTableV2(contentId, tileFilterSelections)

  return (
    <div className="flex h-full min-h-0 flex-col">
      <DataTableV2Content
        tileFilters={<TileFilter schema={data.filters} portalPopover={false} />}
        uiSchema={data.uiSchema}
        dataSchema={data.dataSchema}
        reloadHandler={refetch}
        isRefetching={isRefetching}
      />
    </div>
  )
}
